import { createFileRoute } from "@tanstack/react-router";

import { RequireCapability } from "@components/RequireCapability.tsx";
import { DEPLOYMENT_CAPABILITIES } from "@/AccessPermissions.ts";
import { Deployment } from "@/features/deployment/components/Deployment.tsx";

export const Route = createFileRoute("/deployment/")({
  component: () => (
    <RequireCapability all={DEPLOYMENT_CAPABILITIES}>
      <Deployment />
    </RequireCapability>
  ),
  staticData: { breadcrumb: "menu.deployment" }
});
